import { reservationStatus } from './constant';
const getNumberOfMilliseconds = 8.64e7; // 8.64e7 is the number of milliseconds in a day.
export const getMonth = (epochDate: string) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const dateFormat = new Date(+epochDate * getNumberOfMilliseconds);
  const month = monthNames[dateFormat.getMonth()];
  return `${month}`;
};

export const getYear = (epochDate: string) => {
  const dateFormat = new Date(+epochDate * getNumberOfMilliseconds);
  const fullYear = dateFormat.getFullYear();
  return `${fullYear}`;
};

export const getDay = (epochDate: string) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dateFormat = new Date(+epochDate * getNumberOfMilliseconds);
  const day = days[dateFormat.getDay()];
  return `${day}`;
};

export const getDate = (epochDate: string) => {
  const dateFormat = new Date(+epochDate * getNumberOfMilliseconds);
  const date = dateFormat.getDate();
  return `${date}`;
};

export const getReservationStatus = (status: number) => {
  return Object.values(reservationStatus).find(
    (item: { key: number; status: string }) => item.key === status
  )?.status;
};

export const getNumberOfNights = (checkInEpoch: string, checkOutEpoch: string) => {
  const checkInDate = new Date(+checkInEpoch * getNumberOfMilliseconds).toISOString();
  const checkOutDate = new Date(+checkOutEpoch * getNumberOfMilliseconds).toISOString();
  const timeDiff = Math.abs(new Date(checkInDate).getTime() - new Date(checkOutDate).getTime());
  return Math.ceil(timeDiff / (1000 * 3600 * 24));
};
